<template>
<!-- 用户中心 -->
<section class="viewContainer">
  <!--工具条-->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <!-- 顶部搜索框 -->
    <el-collapse-transition>
    <div v-show="show3">
      <el-form class="findform" :model="filters">
        <el-form-item label="关键词语：" style="display:flex;width:30%">
          <el-input v-model="filters.name" placeholder="请输入昵称/手机号" style="width:90%"/>
        </el-form-item>
        <el-form-item label="登录时间：" style="display:flex;">
          <el-date-picker type="daterange" :title="value6" v-model="value6" style="width:90%"
            :editable="iseditable" value-format="yyyy-MM-dd" @change="changetime"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="共创身份：" style="display:flex;width:20%;">
          <el-select v-model="filters.gcsfModel" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in gcsfArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="设 计 师：" style="display:flex;width:20%;">
          <el-select v-model="filters.sjsModel" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in sjsArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="会员身份：" style="display:flex;width:20%;">
          <el-select v-model="filters.hysfModel" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in hysfArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
      </el-form>
      <el-form class="findform">
        <el-form-item label="所属城市：" style="display:flex;width:30%;">
          <el-cascader v-model="filters.chengshi" placeholder="请选择城市" :options="options"
          style="width:90%" filterable clearable @change="handleChange"/>
        </el-form-item>
        <el-form-item label="注册时间：" style="display:flex;">
          <el-date-picker type="daterange" :title="value6" v-model="value7" style="width:90%"
            :editable="iseditable" value-format="yyyy-MM-dd" @change="changetime1"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="注册渠道：" style="display:flex;width:20%;">
          <el-select v-model="filters.zcqd" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in zcqdArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="店铺员工：" style="display:flex;width:20%;">
          <el-select v-model="filters.dpygModel" filterable placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in dpygArr" :key="index" :label="item.Name" :value="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item style="display:flex;width:20%;"> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">用户中心</p>
    </section>
    <div class="table_container">
      <el-table :data="users" v-loading="listLoading" stripe border>
        <el-table-column prop="num" label="序号" align="center" width="60">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column prop="NickName" label="昵称" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.NickName">{{scope.row.NickName}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="Name" label="姓名" align="center">
          <template scope="scope">
            <span :title="scope.row.Name">{{scope.row.Name}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="Phone" label="手机" align="center" min-width="120">
          <template scope="scope">
            <span :title="scope.row.Phone">{{scope.row.Phone}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="Wechat" label="微信号" width="120" align="center"></el-table-column> -->
        <el-table-column prop="CityName" label="所属城市" align="center" min-width="120">
          <template scope="scope">
            <span :title="scope.row.CityName">{{scope.row.CityName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OrderNum" label="订单数" align="center" width="80">
          <template scope="scope">
            <span :title="scope.row.OrderNum">{{scope.row.OrderNum}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="OrderPrice" label="订单总额" align="center" width="80">
          <template scope="scope">
            <span :title="'￥'+scope.row.OrderPrice">￥{{scope.row.OrderPrice}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="CollectionGoodsNum" label="收藏商品数" align="center">
          <template scope="scope">
            <span :title="scope.row.CollectionGoodsNum">{{scope.row.CollectionGoodsNum}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="VipInfo" label="会员身份" align="center" width="80">
          <template scope="scope">
            <span :title="scope.row.VipInfo">{{scope.row.VipInfo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="IsCo" label="共创身份" align="center" width="80">
          <template scope="scope">
            <span :title="scope.row.IsCo">{{scope.row.IsCo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="IsStaff" label="店铺员工" align="center" width="80">
          <template scope="scope">
            <span :title="scope.row.IsStaff">{{scope.row.IsStaff}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="IsDesigner" label="设计师" align="center" width="80">
          <template scope="scope">
            <span :title="scope.row.IsDesigner">{{scope.row.IsDesigner}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CoOperInfo" label="注册渠道" align="center">
          <template scope="scope">
            <span class="spanList" :title="scope.row.CoOperInfo">{{scope.row.CoOperInfo}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CTime" label="注册时间" align="center" width="150">
          <template scope="scope">
            <span :title="scope.row.CTime">{{scope.row.CTime}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="LastLoginTime" label="最后登陆时间" align="center" width="160">
          <template scope="scope">
            <span :title="scope.row.LastLoginTime">{{scope.row.LastLoginTime}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div style="width:400px;float:left;margin-top:15px;margin-left:5px;">
        共
        <span class="registerNum">{{today}}</span>人,昨日注册
        <span class="registerNum">{{yesterday}}</span>人, 今日注册
        <span class="registerNum">{{nowday}}</span>人
      </div>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :page-size="10" :current-page="pageIndex" :total="total" style="float:right;margin:10px 0;"/>
    </div>
  </div>
</section>
</template>
<script>
import NProgress from "nprogress";
import { provincegetcountys } from '../../api/newOss';
import { userlist, getkind, removeUser } from "../../api/api";
export default {
  data() {
    return {
      show3: true,
      timer:false,
      screenWidth: document.body.clientWidth,
      yesterday: 0,
      iseditable: false,
      value6: "",
      value7: "",
      today: 0,
      nowday: 0,
      rEndTime: "",
      rStartTime: "",
      filters: {
        name: "",
        hysfModel: 0, // 会员身份
        gcsfModel: 0, // 共创身份
        dpygModel: 0, // 店铺员工
        sjsModel: 0, // 设计师
        chengshi: '', // 所属城市
        zcqd: -3, // 注册渠道
        date1: "",
        date2: "",
        vipId: 0
      },
      zcqdArr: [],
      leveloptions: [],
      searchWords: "",
      searchShow: false,
      users: [],
      total: 1,
      page: 1,
      listLoading: false,
      pageIndex: 1,
      pageSize: 10,
      pickerOptions2: {
        disabledDate: time => {
          let beginDateVal = this.filters.date1;

          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      },
      hysfArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "是"
        },
        {
          Id: 2,
          Name: "否"
        }
      ],
      gcsfArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "是"
        },
        {
          Id: 2,
          Name: "否"
        }
      ],
      dpygArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "是"
        },
        {
          Id: 2,
          Name: "否"
        }
      ],
      sjsArr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "是"
        },
        {
          Id: 2,
          Name: "否"
        }
      ],
      options: [],
      provinceId: 0, // 省id
      cityId: 0, // 市id
      zoneId: 0, // 区县
    };
  },
  methods: {
    // 用户管理
    getusermanager() {
      var loginParams = {
        userSource: 0,
        rStartTime: this.rStartTime,
        rEndTime: this.rEndTime,
        key: this.filters.name,
        isVip: this.filters.hysfModel, // 是否为会员       0=全部、1=是、2=否
        isCo: this.filters.gcsfModel, // 是否为共创       0=全部、1=是、2=否
        isStaff: this.filters.dpygModel, // 是否为员工       0=全部、1=是、2=否
        isDesigner: this.filters.sjsModel, // 是否为设计师   0=全部、1=是、2=否
        provinceId: this.provinceId, // 省
        cityId: this.cityId, // 市
        countyId: this.zoneId, // 区
        vipId: this.filters.vipId,
        startTime: this.filters.date1,
        endTime: this.filters.date2,
        userSource: this.filters.zcqd, // 注册渠道
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      userlist(loginParams).then(data => {
        var str = data.ResultMsg;
        var arr = str.split(",");
        this.today = arr[0];
        this.yesterday = arr[1];
        this.nowday = arr[2];
        this.total = data.RowsCount;
        this.users = data.ResultObj;
      }).catch(err => {
        this.total = 0;
        this.users = [];
        this.today = 0;
        this.yesterday = 0;
        this.nowday = 0;
      });
    },
    // 登录时间
    changetime() {
      if(this.value6+""=="null"){
        this.value6 = ["",""]
      }
      this.filters.date1 = this.value6[0];
      this.filters.date2 = this.value6[1];
    },
    // 注册时间
    changetime1() {
      if(this.value7+""=="null"){
        this.value7 = ["",""]
      }
      this.rStartTime = this.value7[0];
      this.rEndTime = this.value7[1];
    },
    // 查询按钮
    onSubmit() {
      this.pageIndex = 1;
      this.getusermanager();
    },
    cancelSearch() {
      this.searchShow = false;
    },

    // 删除
    handleDel: function(row) {
      var _this = this;
      this.$confirm("确认删除该记录吗?", "提示", {
        //type: 'warning'
      }).then(() => {
        _this.listLoading = true;
        NProgress.start();
        let para = {
          id: row.id
        };
        removeUser(para).then(res => {
          _this.listLoading = false;
          NProgress.done();
          this.$swal({
            type:"success",
            text:"删除成功"
          })
          _this.getUsers();
        });
      })
    },
    hide() {
      this.$refs.mySelect.handleClose();
    },
    hide1() {
      this.$refs.mySelect1.handleClose();
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2]; // 区
    },
    // 查找省市
    getprovince() {
      var loginParams = {
        isopen: -1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        const provinceOptions = [];
        data.resultObj.forEach(item => {
          const province = { value: item.pid, label: item.pname, children: [] };
          if (item.citys && item.citys.length > 0) {
            item.citys.forEach(city => {
              const allCityOption = { value: 0, label: "全市" };
              let cityObj;
              if (city.countys && city.countys.length > 0) {
                cityObj = {
                  value: city.cid, label: city.cname,
                  children: [allCityOption].concat(city.countys.map(zone => ({
                    value: zone.scid, label: zone.scname
                  })))
                };
              } else {
                cityObj = { value: city.cid, label: city.cname, children: [allCityOption] };
              }
              province.children.push(cityObj);
            });
          } else {delete province.children;}
          provinceOptions.push(province);
        });
        this.options = provinceOptions;
        this.options.unshift({value: 0, label: "全国"});
      })
    },
    getleveloption() {
      let that = this;
      var loginParams = {
        tableName: "tBDUserLevel",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        let obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        this.leveloptions = data;
      });
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getusermanager();
    },
    // 重置
    fnReset() {
      this.filters = {
        name: "",
        hysfModel: 0, // 会员身份
        gcsfModel: 0, // 共创身份
        dpygModel: 0, // 店铺员工
        sjsModel: 0, // 设计师
        chengshi: '', // 所属城市
        date1: "",
        date2: "",
        // cityId: "", // 城市
        vipId: 0
      },
      this.value6 = "";
      this.value7 = "";
      this.rEndTime = "";
      this.rStartTime = "";
      this.provinceId = 0;
      this.cityId = 0; // 所属城市-市id
      this.zoneId = 0;
      // this.pageIndex = 1;
      // this.getusermanager();
    },
    // 获取注册渠道
    getzhucequdao() {
      let that = this;
      var loginParams = {
        tableName: "BDUserChannel",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        that.zcqdArr = data.ResultObj;
        that.zcqdArr.unshift({
          Id: -3,
          Name: "全部"
        });
      })
    },
  },
  created() {
    this.getprovince(); // 所属城市
    this.getzhucequdao(); // 注册渠道
    this.getusermanager();
    this.getleveloption();
    const that = this
    window.onresize = () => {
        return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
        })()
    }
  },
  watch: {
    "filters.name": {
      handler: function(val, old) {
        this.filters.name = val;
        val ? (this.searchShow = true) : (this.searchShow = false);
      }
    },
  },
  screenWidth(val){
    // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
    if(!this.timer){
      // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
      this.screenWidth = val
      this.timer = true
      let that = this
      setTimeout(function(){
          // 打印screenWidth变化的值
        if(that.screenWidth == 1919||1920){
          this.styleId1 = true
        }
          that.timer = false
      },400)
    }
  }
};
</script>
<style scoped>
.registerNum {
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// user.vue?7914bec7